module.exports = __webpack_public_path__ + "img/sm.c61dcfcc.png";